import { render } from "./HomeNotificationsPage.vue?vue&type=template&id=41727bdd&ts=true"
import script from "./HomeNotificationsPage.vue?vue&type=script&lang=ts"
export * from "./HomeNotificationsPage.vue?vue&type=script&lang=ts"

import "./HomeNotificationsPage.vue?vue&type=style&index=0&id=41727bdd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__